import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import "./productsdetails.css";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import axios from "axios";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Badge from "@mui/material/Badge";
import ProductsListDescription from "../../components/productListDescription/ProductsListDescription";
import ProductsListReview from "../../components/productsListReview/ProductsListReview";

import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { GlassMagnifier } from "react-image-magnifiers";
import { jwtDecode } from "jwt-decode";
import { baseURL } from "../../constants/url";
import { CartContext } from "../../context/CartContext";

function ProductsDetails() {
  const { fetchCartCount } = useContext(CartContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [reviewCount, setReviewCount] = useState(0);
  const [product, setProduct] = useState(null);
  const [variant, setVariant] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [mainImage, setMainImage] = useState(null);
  const [value, setValue] = useState("1");
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedName, setSelectedName] = useState(null);
  const [selectedVariantId, setSelectedVariantId] = useState(null);
  const hasSingleVariant = product?.variants?.length === 1;
  const hasSelectedVariant = !!selectedVariantId;

  
  useEffect(() => {
    axios.get(`${baseURL}common/products/${id}/`)
      .then((res) => {
        
        const productData = res.data;
        if (productData.variants?.length === 1) {
          const onlyVariant = productData.variants[0];
          setVariant(onlyVariant);
          setSelectedColor(onlyVariant.color);
          setSelectedName(onlyVariant.name);
          setSelectedVariantId(onlyVariant.id); //  This is important
          setMainImage(onlyVariant.images?.[0]?.image || null);
          if (onlyVariant.size) {
            setSelectedSize(onlyVariant.size);
          }
        }
        setProduct(productData);
        const firstVariant = productData.variants?.[0];
          setVariant(firstVariant);
          if (firstVariant) {
            setSelectedColor(firstVariant.color);  // Set selectedColor for first load
            setSelectedSize(firstVariant.size);    // Optional: select its size
            if (firstVariant.images?.length > 0) {
              setMainImage(firstVariant.images[0].image);
            }
          }
        if (firstVariant?.images?.length > 0) {
          setMainImage(firstVariant.images[0].image);
        }
        if (firstVariant?.size) {
          setSelectedSize(firstVariant.size);
        }
      })
      .catch((err) => console.error("Error fetching product:", err));
  }, [id]);

  useEffect(() => {
    const fetchReviewCount = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await fetch(`${baseURL}common/ratings/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        if (Array.isArray(data)) {
          const filtered = data.filter((r) => Number(r.product) === Number(id));
          setReviewCount(filtered.length);
        }
      } catch (err) {
        console.error("Error fetching review count:", err);
      }
    };

    fetchReviewCount();
  }, [id]);

  const getValidToken = () => {
    const token = localStorage.getItem("authToken");
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      if (decoded.exp < Date.now() / 1000) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        return null;
      }
      return token;
    } catch {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      return null;
    }
  };

  const handleSizeSelect = (variantId) => {
     setSelectedSize(variantId); // or setSelectedVariantId
  };

  console.log("select size jk", selectedSize)

  const handleAddToCart = async () => {
  const token = getValidToken();
  if (!token) {
    Swal.fire({
      icon: "error",
      title: "Please login to continue",
      confirmButtonText: "Login",
    }).then(() => navigate("/login"));
    return;
  }

  if (!hasSelectedVariant && !hasSingleVariant) {
    Swal.fire({
      icon: "warning",
      title: "Please select a size or variant",
      text: "You must select a variant before adding to cart.",
    });
    return;
  }

  try {
    const response = await fetch(`${baseURL}common/cart/add/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        variant_id: selectedVariantId,
        quantity: 1,
      }),
    });

    const data = await response.json();
    if (response.ok) {
      fetchCartCount();
      Swal.fire({
        icon: "success",
        title: "Added to Cart",
        text: "Product successfully added to your cart.",
        timer: 2000,
        showConfirmButton: false,
      });
    } else {
      throw new Error(data.detail || "Failed to add to cart");
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: error.message || "Unable to add product to cart.",
    });
  }
};

   


const handleBuyNow = () => {
      const token = getValidToken();
      if (!token) {
        Swal.fire({
          icon: "error",
          title: "Please login to continue",
          confirmButtonText: "Ok",
        }).then(() => navigate("/login"));
        return;
      }

      if (!variant) {
        Swal.fire({
          icon: "warning",
          title: "No variant selected",
          text: "Please select a color and size before continuing.",
        });
        return;
      }

      navigate("/buynowaddress", {
        state: {
          product: {
            ...product,
            size: [selectedSize],
            weight: [`${variant?.unit_value || ""} ${variant?.unit || ""}`],
            variants: [variant], // pass selected variant here
          },
        },
      });
    };

 console.log("products data", product)

  const getUniqueVariantsByNameAndColor = (variants) => {
      const seen = new Set();
      return variants.filter((variant) => {
        const key = `${variant.name?.toLowerCase()}-${variant.color?.toLowerCase()}`;
        if (!seen.has(key)) {
          seen.add(key);
          return true;
        }
        return false;
      });
    };

  if (!product || !variant) return <p>Loading product...</p>;


  return (
    <>
      <Header />
      <div className="container mt_20">
        <div className="row">
          <div className="col-md-5">
            <div className="image-section">
              <div className="img_zooms" style={{ position: "relative", height: "400px", overflow: "hidden" }}>
                {mainImage && (
                  <GlassMagnifier
                    imageSrc={mainImage}
                    imageAlt={product.name || "Product Image"}
                    largeImageSrc={mainImage}
                    magnifierSize="100%"
                    magnifierBorderColor="rgba(0,0,0,0.3)"
                    magnifierBorderSize={2}
                    style={{ height: "100%", objectFit: "contain" }}
                  />
                )}
              </div>
              <div className="thumbnail-container mt_10">
                {variant.images?.map((imgObj, index) => (
                  <img
                    key={imgObj.id || index}
                    src={imgObj.image}
                    alt={`Thumbnail ${index + 1}`}
                    onClick={() => setMainImage(imgObj.image)}
                    className="thumbnail"
                    style={{
                      cursor: "pointer",
                      border: mainImage === imgObj.image ? "2px solid #f99023" : "1px solid #ccc",
                      maxWidth: "60px",
                      marginRight: "10px",
                      padding: "2px",
                    }}
                  />
                ))}
              </div>
            </div>
            <p className="product_sub_title">{variant.sku}</p>
          </div>

          <div className="col-md-7">
            <div className="details-section">
              <div className="product-code">PRODUCT CODE: {product.id}</div>
              <div className="product-title">{product.name}</div>
              {/* <p className="product_sub_title">{variant.sku}</p> */}

              <div>
                <span className="price mr_20">₹{variant.final_price} </span>
                <span className="price_discount price_cut mr_20">
                  <s>₹{variant.price}</s>
                </span>
                <span className="price_discount_percentage color_green">
                  ({variant.discount_percent}% Off)
                </span>
              </div>

              <div className="reviews mt_10">
                <div className="d_flex gap_5 align_center">
                  <p className="font_13">
                    <span className="rating_box">
                      {variant.average_rating || 0}.0 <StarIcon />
                    </span>
                  </p>
                  <span>Rating</span>
                </div>
              </div>

              <div className="options_box">
                <div className="options_box_in">
                  {/* {variant.size && (
                    <div className="d_flex gap_20 align_center mt_15">
                      <div className="size_box">Size</div>
                      <div className="size_blocks">
                        <ul>
                          <li>
                            <Link to="#" className="active">{variant.size}</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )} */}
                 
                 {/* === SIZE + COLOR for piece/pair === */}
{["piece", "pair"].includes(variant.unit?.toLowerCase()) ? (
  <>
    {/* Size Selector */}
    {selectedColor && product.variants.some((v) => v.size) && (
      <div className="variant-selector mt_20">
        <p className="font_13">Size:</p>
        <div className="d_flex gap_10 flex_wrap">
          {product.variants
            .filter(
              (v) =>
                v.color?.toLowerCase() === selectedColor?.toLowerCase() && v.size
            )
            .map((v) => (
              <div
                key={v.id}
                onClick={() => {
                  setVariant(v);
                  setSelectedSize(v.size || "");
                  if (v.images?.[0]) setMainImage(v.images[0].image);
                  setSelectedVariantId(v.id);
                }}
                className={`variant-option font_13 ${
                  v.size === selectedSize ? "active" : ""
                }`}
                style={{
                  padding: "2px 6px",
                  border:
                    v.size === selectedSize
                      ? "2px solid #f99023"
                      : "1px solid #ccc",
                  cursor: "pointer",
                  borderRadius: "4px",
                  fontWeight: "bold",
                  minWidth: "30px",
                  textAlign: "center",
                }}
              >
                {v.size}
              </div>
            ))}
        </div>
      </div>
    )}
  </>
) : (
  <>
    {variant.unit_value && variant.unit && !["piece", "pair"].includes(variant.unit?.toLowerCase()) && (
  <div className="variant-selector mt_20">
    <p className="font_13">Weight/Volume:</p>
    <div className="font_14 font_bold">
      {variant.unit_value} {variant.unit}
    </div>
  </div>
)}
  </>
)}


                  

                </div>
              </div>
                    {/* {product.variants?.length > 1 && (
                      <div className="variant-selector mt_20">
                        <p>Select Color:</p>
                        <div className="d_flex gap_10 flex_wrap">
                          {product.variants.map((v, index) => (
                            <div
                              key={v.id}
                              onClick={() => {
                                setVariant(v);
                                if (v.images?.[0]) setMainImage(v.images[0].image);
                                setSelectedSize(v.size || "");
                              }}
                              className={`variant-option ${v.id === variant.id ? "active" : ""}`}
                            >
                              <img
                                src={v.images?.[0]?.image}
                                alt={`Variant ${index}`}
                                style={{ width: 60, height: 60, objectFit: "contain" }}
                              />
                              <p style={{ fontSize: 12 }}>{v.color || v.size || `Variant ${index + 1}`}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )} */}

                    {product.variants?.length > 0 && (
                      <div className="variant-selector mt_20">
                        <p className="font_13">Colors :</p>
                        <div className="d_flex gap_10 flex_wrap">
                          {getUniqueVariantsByNameAndColor(product.variants).map((v, index) => (
                            <div
                              key={v.id}
                              onClick={() => {
                                setVariant(v);
                                setSelectedColor(v.color);
                                setSelectedName(v.name);
                                  setSelectedSize(v.size || "");
                                  setSelectedVariantId(v.id); // set variantId as well for cart
                                  if (v.images?.length > 0) {
                                    setMainImage(v.images[0].image);
                                  }
                              }}
                              className={`variant-option ${v.id === variant?.id ? "active" : ""}`}
                              style={{
                                padding: "3px",
                                border: v.id === variant?.id ? "2px solid #f99023" : "1px solid #ccc",
                                cursor: "pointer",
                                borderRadius: "4px",
                                fontWeight: "bold",
                              }}
                            ><img
                                src={v.images?.[0]?.image}
                                alt={`Variant ${index}`}
                                style={{ width: 50, height: 50,borderRadius: "6px", objectFit: "contain" }}
                              /> 
                            </div>
                          ))}
                        </div>
                      </div>
                    )}


              <div className="d_flex gap_20 align_center">
                <div className="buttons">
                  <button className="add-cart-btn" onClick={handleBuyNow}>Buy Now</button>
                </div>
                <div className="buttons">
                  <button className="add-cart-btn" onClick={handleAddToCart}>Add Cart</button>
                </div>
              </div>

              <div className="delivery-info mt_10">
                DELIVERY ESTIMATE
                <br />
                Read our Terms and Conditions
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mt_30">
            <div className="products_list_details pb_30 mt_20">
              <Box sx={{ width: "100%", typography: "body1", mt: 4 }}>
                <TabContext value={value}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList onChange={(e, v) => setValue(v)} variant="scrollable">
                      <Tab label="Description" value="1" />
                      <Tab label="Review" value="3" />
                      <Badge badgeContent={reviewCount} color="primary"></Badge>
                    </TabList>
                  </Box>
                  <TabPanel value="1"><ProductsListDescription /></TabPanel>
                  <TabPanel value="3"><ProductsListReview productId={product?.variants[0]?.id} /></TabPanel>
                </TabContext>
              </Box>
            </div>
          </div>
        </div>
      </div>

      <Subscribe />
      <Footer />
    </>
  );
}

export default ProductsDetails;
